
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 131 51","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.139 0h8.196v34.615H44.14V0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M61.967 16.385h8.4l8.897 28.743h.494l8.897-28.743h8.461L85.93 51H73.135L61.967 16.385z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M0 0h8.403L17.3 28.746h.494L26.69 0h8.46L23.971 34.615h-12.8L0 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M131 28.1h-16.562v-8.264h13.053v-5.688h-13.053V6.515H131V0h-24.568v34.615H131v-6.514z","fill":"currentColor"}})])
          )
        }
      }
    